var map = {
	"./adult/nn/2 7 Ordkjedetest-Starter-testen.mp3": 579,
	"./adult/no/2 7 Ordkjedetest-Starter-testen.mp3": 580,
	"./youth/de/2 7 Ordkjedetest-Starter-testen.mp3": 581,
	"./youth/nn/2 7 Ordkjedetest-Starter-testen.mp3": 582,
	"./youth/no/2 7 Ordkjedetest-Starter-testen.mp3": 583,
	"./youth/se/2 7 Ordkjedetest-Starter-testen.mp3": 584
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 578;